import styled from 'styled-components'

export const ModuleContainer = styled.div`
  overflow-y: scroll;
  min-height: calc(100vh - 50px);
  height: calc(100vh - 50px);
  margin-right: 0px;
  padding-top: 1em;
`